export default "__VITE_ASSET__DinkfSeF__"